import { S as Swiper, N as Navigation } from './navigation-BCY3s7EV.js';
import { fetchHTML } from './utils-fetch-html.js';

class UpsellCarousel extends HTMLElement {
  connectedCallback() {
    this.swiper = null;
    this.navigation = null;
    this.initSwiper();
    this.unsubscribeCartRemoved = subscribe('cart:removed', () => this.refreshUpsellCarousel());
    this.unsubscribeCartAdded = subscribe('cart:added', () => this.refreshUpsellCarousel());
    this.unsubscribeCartChange = subscribe('cart:updated', () => this.refreshUpsellCarousel());
  }

  disconnectedCallback() {
    this.unsubscribeCartRemoved();
    this.unsubscribeCartAdded();
    this.unsubscribeCartChange();
  }

  initSwiper() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
    }

    this.navigation = this.querySelector('.swiper-button-prev, .swiper-button-next');
    let sliderNavigation = '';
    if (this.navigation) {
      sliderNavigation = {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      };
    }

    this.swiper = new Swiper(this.querySelector('.swiper'), {
      modules: [Navigation],
      slidesPerView: 2.5,
      centeredSlides: false,
      breakpoints: {
        768: {
          slidesPerView: 3,
        },
      },
      navigation: sliderNavigation,
      spaceBetween: 24,
      loop: true,
      threshold: 10,
    });
  }

  async refreshUpsellCarousel() {
    const html = await fetchHTML(`${Shopify.routes.root}cart?section_id=fetch-upsell-carousel`);
    const target = html.querySelector('upsell-carousel').innerHTML;
    this.innerHTML = target;
    this.initSwiper();
  }
}

customElements.define('upsell-carousel', UpsellCarousel);
